import { styled } from 'styled-components';

import { tokens } from '@pkg/components/filters/FilterCollection/FilterCollection.tokens.ts';
import { styledReset } from '@pkg/primitives';

export const List = styled.ul`
    ${styledReset.list};
    display: grid;
    gap: ${tokens.action.padding}px;
    margin-left: ${tokens.action.padding * -1}px;
    margin-right: ${tokens.action.padding * -1}px;
`;

export const Item = styled.li``;
